module.exports = __webpack_public_path__ + "static/media/kimdonpat68.b9826424.png";